import { Pipe, PipeTransform } from "@angular/core";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";

@Pipe({
  name: "shiftStyle"
})
export class ShiftStylePipe implements PipeTransform {
  transform(value?: NsEmpWebExpData.IShiftData, selectedLoginShift?: object, selectedLogoutShift?: object, nextDayLogoutShift?: object): boolean {
    return selectedLoginShift === value || selectedLogoutShift === value || nextDayLogoutShift === value;
  }
}
